export const decodeHTMLEntities = (text: string | null | undefined): string => {
    if (!text) return "";
    try {
        const parser = new DOMParser();
        const decodedString = parser.parseFromString(text, "text/html").body.textContent;
        return decodedString || text;
    } catch (e) {
        console.error("Errore decodifica HTML entities:", e);
        return text; // Ritorna il testo originale in caso di errore
    }
};